import React, { Component } from "react";
import { connect } from "react-redux";

import SideBar from "app/DealMachineCore/components/SideBar";

class AppSideBar extends Component {
  render() {
    if (this.props.open) {
      return (
        <div
          className={
            this.props.mobile_toggle_drawer ? "dm-sidebar open" : "dm-sidebar"
          }
        >
          <SideBar />
        </div>
      );
    }

    return <div />;
  }
}

const mapStateToProps = ({ drawer, native }) => {
  const { open } = drawer;
  const { isMobile, mobile_toggle_drawer } = native;
  return { open, isMobile, mobile_toggle_drawer };
};

export default connect(mapStateToProps, {})(AppSideBar);
